import { MatcherGenericTextAreaStep } from '../components';

function MatcherQuestionStep() {
  return (
    <MatcherGenericTextAreaStep
      questionId="question"
      title="What questions do you have for your tax pro?"
      placeholder="e.g. How much should I be withholding?"
      maxLength={140}
      stepName="matcher_question_step"
    />
  );
}

export { MatcherQuestionStep };
